import { render, staticRenderFns } from "./ProviderDevolutions.vue?vue&type=template&id=32336a93"
import script from "./ProviderDevolutions.vue?vue&type=script&lang=js"
export * from "./ProviderDevolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports